export default {
  notificationTitle: {
    en: 'Thanks for your feedback!',
  },
  notificationText: {
    en: 'We hope to see you again sometime very soon.',
  },
}
